// removed by extract-text-webpack-plugin
module.exports = {"root":"episode__root","link":"episode__link","selected":"episode__selected","heading":"episode__heading","watchASLogo":"episode__watchASLogo","identifier":"episode__identifier","title":"episode__title","description":"episode__description"};


//////////////////
// WEBPACK FOOTER
// ./src/show-page/components/episode/styles.less
// module id = 489
// module chunks = 1